module.exports = __webpack_public_path__ + "img/8.806bb759.jpg";